import PropTypes from 'prop-types';
import { Draggable } from '../../DndKit';

import { buildClass } from '../../../libs/classes';
import { ItemTypeDelimiter } from '../../../utils/items';
import SampleTile from './SampleTile';

/**
 * Draggable version of sample tile
 * @component
 */
export const SampleTileDraggable = (props) => {
	const draggableId = props.type + ItemTypeDelimiter + props.sample.id;

	return (
		<Draggable draggableId={draggableId} index={props.index} key={props.sample.id}>
			{(provided, _snapshot) => (
				<div
					className={buildClass('drag-tile')}
					ref={provided.innerRef}
					{...provided.draggableProps}
					{...provided.dragHandleProps}
				>
					<SampleTile {...props} />
				</div>
			)}
		</Draggable>
	);
};

SampleTileDraggable.propTypes = {
	...SampleTile.propTypes,
	// Draggable item type
	type: PropTypes.string.isRequired,
};

export default SampleTileDraggable;
